import {Decimal} from 'decimal.js';

const _sizeCache = new Map();

const cacheNaturalSize = (src, width, height) => {
        if (src && width > 0 && height > 0) {
                _sizeCache.set(src, { width, height });
        }
};

const fittedSize = (desiredSize, actualSize) => {
        // Guard: zero or missing dimensions produce NaN ratios and Infinity scales downstream
        if (!desiredSize || !actualSize
                || desiredSize.width <= 0 || desiredSize.height <= 0
                || actualSize.width <= 0 || actualSize.height <= 0) {
                return { width: 0, height: 0 };
        }

        const desiredRatio = Decimal.div(desiredSize.width, desiredSize.height);
        const actualRatio = Decimal.div(actualSize.width, actualSize.height);

        if (desiredRatio.eq(actualRatio)) {
                return actualSize;
        }

        if (actualRatio.gt(desiredRatio)) {
                // Image is wider than the view: constrain by height, crop the sides
                return {
                        width: Decimal.mul(actualSize.height, desiredRatio).round().toNumber(),
                        height: actualSize.height,
                };
        }

        // Image is taller than the view: constrain by width, crop top/bottom
        return {
                width: actualSize.width,
                height: Decimal.div(actualSize.width, desiredRatio).round().toNumber(),
        };
};

const naturalSize = (src) => {
        if (!src) {
                return { width: 0, height: 0 };
        }
        const cached = _sizeCache.get(src);
        if (cached) {
                return cached;
        }
        let image = new Image();
        image.src = src;
        const size = { width: image.naturalWidth, height: image.naturalHeight };
        if (size.width > 0 && size.height > 0) {
                _sizeCache.set(src, size);
        }
        return size;
};

const zoomedInSize = (fitSize, zoom) => {
        // Guard: zoom <= 0 would invert to Infinity; treat as no-zoom
        if (!zoom || zoom <= 0) {
                return { width: fitSize.width, height: fitSize.height };
        }
        const zoomIn = new Decimal(zoom).pow(-1);
        return {
                width: Decimal.mul(fitSize.width, zoomIn).round().toNumber(),
                height: Decimal.mul(fitSize.height, zoomIn).round().toNumber(),
        };
};

const ImageUtils = {
        cacheNaturalSize,
        fittedSize,
        naturalSize,
        zoomedInSize,
};
export default ImageUtils;
